var $ = jQuery;
$(function() {
	function computeLoanGraph() {
		var loanAmt = parseFloat($("#balance").val()),
			dpAmt = loanAmt * (parseFloat($("#dpRate").val()) / 100),
			principal = loanAmt - dpAmt,
			terms = parseInt($("#term").val()),
			intRate = parseFloat($("#rate").val()) / 100,
			freq = parseInt($("#period").val()),
			currDate = new Date();

		var intPerFreq = intRate / freq,
			paymentPerFreq =
				(principal *
					intPerFreq *
					Math.pow(1 + intPerFreq, terms * freq)) /
				(Math.pow(1 + intPerFreq, terms * freq) - 1),
			yearlySched = [];

		// console.log(intPerFreq, (1 - (1+intPerFreq)), (-terms * freq), divisor, paymentPerFreq);
		function commaSeparateNumber(val) {
			while (/(\d+)(\d{3})/.test(val.toString())) {
				val = val.toString().replace(/(\d+)(\d{3})/, "$1" + "," + "$2");
			}
			return val;
		}
		var roundedRate = paymentPerFreq.toFixed(2);

		roundedRate = commaSeparateNumber(roundedRate);
		rate = $("#rate").val();
		dpRate = $("#dpRate").val();
		balance = $("#balance").val();
		if (balance == "" || balance < 0) {
			$(".total-rate").html(
				"<span style='color:red; font-size:12px; font-style: italic;'>Please update the highlighted field</span>"
			);
			$("#balance").html(" ");
			$("#balance").css({
				border: "2px solid red"
			});
		} else if (rate == "" || rate > 100 || rate <= 0) {
			$(".total-rate").html(
				"<span style='color:red; font-size:12px; font-style: italic;'>Please update the highlighted field</span>"
			);
			$("#rate").html(" ");
			$("#rate").css({
				border: "2px solid red"
			});
		} else if (
			dpRate == "" ||
			dpRate > 100 ||
			dpRate < 0 ||
			paymentPerFreq <= 0
		) {
			$(".total-rate").html(
				"<span style='color:red; font-size:12px; font-style: italic;'>Please update the highlighted field</span>"
			);
			$("#dpRate").html("");
			$("#dpRate").val("");
			$("#dpRate").css({
				border: "2px solid red"
			});
		} else if (!roundedRate) {
			$(".total-rate").html(
				"<span style='color:red; font-size:12px; font-style: italic;'>Please update the highlighted field</span>"
			);
			$("#balance").html(" ");
			$("#rate").html(" ");
			$("#dpRate").html(" ");
		} else {
			$(".total-rate").html("$" + roundedRate);
		}
		var remaining = principal,
			currYear = currDate.getFullYear(),
			dateLoop = new Date(currYear, currDate.getMonth(), 1),
			monthIncrement = 1,
			currYearCount = 0;

		switch (freq) {
			case 1:
				monthIncrement = 12;
				break;
			case 2:
				monthIncrement = 6;
				break;
			case 4:
				monthIncrement = 3;
				break;
			default:
				monthIncrement = 1;
		}
		yearlySched.push({
			year: currYear,
			interest: 0,
			principal: 0,
			balance: principal * (1 + intPerFreq) - paymentPerFreq
		});

		// x.setMonth(x.getMonth() + 1);
		while (remaining > 0) {
			var bal = remaining * (1 + intPerFreq) - paymentPerFreq;

			if (bal > 0) {
				if (dateLoop.getFullYear() == yearlySched[currYearCount].year) {
					yearlySched[currYearCount].interest =
						yearlySched[currYearCount].interest +
						remaining * intPerFreq;
					yearlySched[currYearCount].principal =
						yearlySched[currYearCount].principal +
						(paymentPerFreq - remaining * intPerFreq);
					yearlySched[currYearCount].balance = bal; //(remaining*(1+intPerFreq) - paymentPerFreq);
					// if(yearlySched[currYearCount].year == 2045){
					// console.log(dateLoop.getMonth(), monthIncrement, yearlySched[currYearCount].year, yearlySched[currYearCount].principal);
					// }
				} else {
					yearlySched.push({
						year: dateLoop.getFullYear(),
						interest: remaining * intPerFreq,
						principal: paymentPerFreq - remaining * intPerFreq,
						balance: bal
					});
					currYearCount++;
					// if(yearlySched[currYearCount].year == 2045)
					// console.log(dateLoop.getMonth(), monthIncrement, yearlySched[currYearCount].year, yearlySched[currYearCount].principal);
				}
				// console.log(remaining, paymentPerFreq - (remaining*intPerFreq));
				dateLoop.setMonth(dateLoop.getMonth() + monthIncrement);
				remaining -= paymentPerFreq - remaining * intPerFreq;
			} else break;
		}
		yearlySched[currYearCount].balance = 0;
		/*console.log(yearlySched);*/
		amT = 0;

		$.each(yearlySched, function(key, value) {
			if (amT % 2 == 0) {
				className = "even";
			} else {
				className = "odd";
			}
			var year = value.year,
				interest = value.interest.toFixed(2),
				principal = value.principal.toFixed(2),
				balance = value.balance.toFixed(2);

			interest = commaSeparateNumber(interest);
			principal = commaSeparateNumber(principal);
			balance = commaSeparateNumber(balance);
			htmlObject =
				"<div class='year col-xs-6 column " +
				className +
				"'>" +
				year +
				"</div><div class='interest col-xs-6 column " +
				className +
				"'>" +
				interest +
				"</div><div class='principal col-xs-6 column " +
				className +
				"'>" +
				principal +
				"</div><div class='balance col-xs-6 column " +
				className +
				"'>" +
				balance +
				"</div></li>";
			$(".amortization-result").append(htmlObject);
			amT++;
		});

		var graphWidth = $(".calculator").width();
		if (windowWidth >= 641) {
			var grapHeight = 500;
		} else {
			grapHeight = 300;
		}
		d3chart([], yearlySched, graphWidth, grapHeight);
		$(window).resize(function() {
			windowWidth = $(window).width();
			$(".amortization-graph").empty();
			graphWidth = $(".calculator").width();

			if (windowWidth <= 640) {
				grapHeight = 300;
			} else if (windowWidth >= 641) {
				grapHeight = 500;
				graphWidth = graphWidth - 30;
				// var time = setTimeout(function(){

				$(".y2.axis>text").attr("x", "5");
				$(".y2.axis>text").attr("y", "13");
				$(".y.axis>text").attr("x", "6");
				$(".y.axis>text").attr("y", "-20");
				$(".y2.axis .tick")
					.find("line")
					.attr("x2", "6");
				$(".y2.axis .tick")
					.find("text")
					.attr("x", "60");
				$(".y2.axis .tick")
					.find("text")
					.eq(0)
					.attr("x", "20");
				// }, 10);
			}
			d3chart([], yearlySched, graphWidth, grapHeight);
		});
	}

	$(".calcu-btn a").click(function() {
		$(".amortization-result").empty();
		$(".amortization-graph").empty();
		computeLoanGraph();
    });
    $(".calcu-btn a").keypress(function() {
        if (event.keyCode === 32 || event.keyCode === 13) {
            $(".amortization-result").empty();
            $(".amortization-graph").empty();
            computeLoanGraph();
        }
	});
	function d3chart(error, data, graphWidth, grapHeight) {
		graphWidth = graphWidth - 37.5;
		//set SVG area variables

		var margin = { top: 20, right: 20, bottom: 30, left: 50 },
			width = graphWidth - margin.left - margin.right,
			height = grapHeight - margin.top - margin.bottom;

		var length = data.length;
		var dataset = data;

		// var parseDate = d3.time.format("%Y-%m-%d").parse;

		//set Width Control Variables
		var barRawWidth = width / (data.length + 2);
		var barPadding = 0;
		var xStart = barPadding + barRawWidth / 2;
		var barWidth = barRawWidth - barPadding * 2;

		//set Graph scaling
		var x = d3.scale.linear().range([0, width]);

		var y = d3.scale.linear().range([height, 0]);

		var y2 = d3.scale.linear().range([height, 0]);

		var xAxis = d3.svg
			.axis()
			.scale(x)
			.orient("bottom")
			.tickFormat(d3.format("d"));

		var yAxis = d3.svg
			.axis()
			.scale(y)
			.orient("left");

		if (windowWidth >= 641) {
			var yAxis2 = d3.svg
				.axis()
				.scale(y2)
				.orient("right");
		} else {
			var yAxis2 = d3.svg
				.axis()
				.scale(y2)
				.orient("left");
		}

		//settings for Line graph for Balance
		var line = d3.svg
			.line()
			.x(function(d) {
				return x(d.year);
			})
			.y(function(d) {
				return y2(d.balance);
			});

		//append svg to body
		var svg = d3
			.select(".amortization-graph")
			.append("svg")
			.attr("width", width + margin.left + margin.right)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr(
				"transform",
				"translate(" + margin.left + "," + margin.top + ")"
			);

		// function for the x grid lines
		function make_x_axis() {
			return d3.svg
				.axis()
				.scale(x)
				.orient("bottom")
				.ticks(length);
		}

		// function for the y grid lines
		function make_y_axis() {
			return d3.svg
				.axis()
				.scale(y)
				.orient("right")
				.ticks(length);
		}

		// var length = data.length;

		// for (var i = 0; i < length; i++) {
		//     data[i].year = parseDate(data[i].year);
		//     data[i].balance = +data[i].balance;
		// }

		//set x,y domains
		//*IGNORE - var nxExtent = [d3.time.year.offset(xExtent[0], -1), d3.time.year.offset(xExtent[1], 1)];

		//x, y domain settings
		var xExtent = [
			data[0].year,
			d3.max(data, function(d) {
				return d.year + 1;
			})
		];
		var yExtent = [
			0,
			d3.max(data, function(d) {
				return d.principal + 5000;
			})
		];
		var yExtent2 = [
			0,
			d3.max(data, function(d) {
				return d.balance;
			})
		];

		x.domain(xExtent);
		y.domain(yExtent);
		y2.domain(yExtent2);

		var heights = [];
		//Append Interests Bar Chart
		svg.selectAll("interest")
			.data(data)
			.enter()
			.append("rect")
			.attr("class", "interest")
			.attr("x", function(d) {
				return x(d.year);
			})
			.attr("width", barWidth)
			.attr("y", function(d) {
				var pushtop = -(height - y(d.principal));
				return pushtop + y(d.interest);
			})
			.attr("height", function(d) {
				return height - y(d.interest);
			});

		//Append Principals Bar Chart
		svg.selectAll("principal")
			.data(data)
			.enter()
			.append("rect")
			.attr("class", "principal")
			.attr("x", function(d) {
				return x(d.year);
			})
			.attr("width", barWidth)
			.attr("y", function(d) {
				return y(d.principal);
			})
			.attr("height", function(d) {
				return height - y(d.principal);
			});

		//Create X Axis Grids
		svg.append("g")
			.attr("class", "grid")
			.attr("transform", "translate(0," + height + ")")
			.call(
				make_x_axis()
					.tickSize(-height, 0, 0)
					.tickFormat("")
			);

		//Create Y Axis Grids
		svg.append("g")
			.attr("class", "grid")
			.call(
				make_y_axis()
					.tickSize(-width, 0, 0)
					.tickFormat("")
			);

		//X-Axis
		svg.append("g")
			.attr("class", "x axis")
			.attr("transform", "translate(0," + height + ")")
			.call(xAxis);

		//Y-Axis
		svg.append("g")
			.attr("class", "y axis")
			.call(yAxis)
			.append("text")
			.attr("transform", "rotate(-90)")
			.attr("y", 6)
			.attr("dy", ".71em")
			.style("text-anchor", "end")
			.text("($)");

		svg.append("g")
			.attr("class", "y2 axis")
			.attr("transform", "translate(" + width + ",0)")
			.call(yAxis2)
			.append("text")
			.attr("transform", "rotate(-90)")
			.attr("x", 0)
			.attr("y", 6)
			.attr("dy", ".71em")
			.style("text-anchor", "end")
			.text("($)");

		//Append Line graph for Balance
		svg.append("path")
			.datum(data)
			.attr("class", "line")
			.attr("d", line);

		//Append Plots for Balance
		svg.selectAll("dot")
			.data(data)
			.enter()
			.append("circle")
			.attr("class", "dots")
			.attr("r", 3.5)
			.attr("fill", "red")
			.attr("cx", function(d) {
				return x(d.year);
			})
			.attr("cy", function(d) {
				return y2(d.balance);
			})
			.attr("title", function(d) {
				var title = d.year + " " + d.balance;
				return title;
			});
	}
	function getLoanValues() {
		var vars = [],
			hash;
		var hashes = window.location.href
			.slice(window.location.href.indexOf("?") + 1)
			.split("&");
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split("=");
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
	var windowWidth = $(window).width();
	var lCBalance = getLoanValues()["balance"];
	var lCDpRate = getLoanValues()["downpayment"];
	var lCTerm = getLoanValues()["term"];
	var lCRate = getLoanValues()["rate"];
	var lCPeriod = getLoanValues()["period"];
	var pagename = window.location.pathname;

	if (lCBalance && lCDpRate && lCTerm && lCRate && lCPeriod) {
		$("#balance").val(lCBalance);
		$("#dpRate").val(lCDpRate);
		$("#term").val(lCTerm);
		$("#rate").val(lCRate);
		$("#period").val(lCPeriod);

		computeLoanGraph();
		$(".amortization-graph").fadeIn(function() {
			$(".amortization-table").fadeIn();
		});
	}
	$(".amortization-link").click(function() {
        event.preventDefault();
		if ($(".amortization-graph").html() != "") {
			$(".amortization-graph").fadeIn(function() {
				$(".amortization-table").fadeIn();
			});
		}
	});
});
